/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { FormControl, Select, MenuItem } from "@mui/material";
import LabelledField from "components/labelled-field/index";
import { isArrayNotEmpty, isFalse, isTrue, isValidOption } from "utils/empty-exists";
// import { Logger } from "cms/utils/log/logger";

const SettingsStyleEdit = (props) => {
    
    const label = props?.label;
    const itemLocalState = props?.itemLocalState;
    const setItemLocalState = props?.setItemLocalState;
    const disabled = props?.disabled;
    const styleOptions = props?.styleOptions;
    const selected = props?.selected;
    const index = props?.index;
    const update = props?.update;
    
    const _style = itemLocalState?.settings?.style;
    const styleValue = isValidOption(_style, styleOptions) ? _style : "field.style.body";
    const { t } = useTranslation();
    
    const onChangeStyle = (event) => {
        // use new value unless none was selected
        const value = event.target.value;
        let updatedValue = (value !== null) ? value : selected;
        updatedValue = (updatedValue !== "field.style.none") ? updatedValue : selected;
        // Logger.debug(value?.value)
        const newState = {
            ...itemLocalState,
            value: itemLocalState?.value || "",
            settings: {
                style: updatedValue,
                format: itemLocalState?.settings?.format,
                options: itemLocalState?.settings?.options,
            },
        };
        setItemLocalState(newState);
        update(newState,index);
    };
    
    return (
        <Fragment>
            {isFalse(disabled) &&
                <LabelledField label={label ? label : t("commons.displayStyle")} className='labelField'>
                    {isArrayNotEmpty(styleOptions) && (
                        <FormControl sx={{ mt: 1, mb: 1, width: "100%" }} size="small">
                            <Select
                                labelId='demo-select-small-label'
                                id='link-style-select'
                                value={styleValue}
                                fullWidth={true}
                                disabled={disabled}
                                variant='standard'
                                onChange={onChangeStyle}
                            >
                                <MenuItem value='field.style.none'>Select...</MenuItem>
                                {styleOptions.map((option, index) =>
                                    <MenuItem key={index} value={option?.value}>{option?.name}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    )}
                    
                </LabelledField>
            }
            {/*<p>{styleValue}</p>*/}
            {/*<p>{JSON.stringify(styleOptions, null,2)}</p>*/}
            {isTrue(disabled) &&
                <div
                    style={{
                        width: "100%",
                        height: "64px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#7A7A7A",
                    }}
                >
                    {t("commons.thisContentCanNotBeChanged")}
                </div>
            }
        </Fragment>
    );
};
export { SettingsStyleEdit };
